import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RapportIncidentTypeIncident, RapportIncidentTypeIncidentDetail } from 'src/api/models';

@Component({
  selector: 'app-rapport-incident-type-detail',
  templateUrl: './rapport-incident-type-detail.component.html',
  styleUrls: ['./rapport-incident-type-detail.component.css']
})
export class RapportIncidentTypeDetailComponent implements OnInit {
  @Input() public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetRapportIncidentTypeDetail(t: RapportIncidentTypeIncidentDetail) {
    if (t === undefined || t == null) {
      return '';
    } else {
      return this.translateService.instant('Rapports.RapportsIncidents.TypesIncidentsDetail.' + RapportIncidentTypeIncident[t]);
    }
  } 
}
